const Path = {
  Slash: '/',
  Vehicle: '/vehicle',
  Member: '/member',
  MemberList: '/member/list',
  AddMember: '/member/add',
  MemberAccount: '/member/account',
  Index: '/index',
  Auth: '/auth',
  Activity: '/activity',
  Transaction: '/transaction',
  TransactionProduct: '/transaction/:product',
  TransactionByProduct: (product) => `/transaction/${product}`,
  Users: '/users',
  Products: '/products'
};

export default Path;
